import { Injectable } from '@angular/core';
import { dsDtos, webDtos } from '@vectronic/openApi-admin';
import { Translator } from '@vectronic/util';

@Injectable({ providedIn: 'root' })
export class CommandContentService {
  getCommandString(row: dsDtos.Command | webDtos.CustomerCommand) {
    return Translator.deviceCommand(row?.deviceCommand);
  }

  getScheduleStrings(row: dsDtos.Command | webDtos.CustomerCommand) {
    return row?.schedules?.map((schedule) => `${schedule.scheduleType} Schedule`) || [];
  }

  getParameterStrings(
    row: dsDtos.Command | webDtos.CustomerCommand,
    parameters: dsDtos.Parameter[],
  ) {
    return (
      row?.parameterDataList?.map((parameterData) => {
        const parameter = parameters?.find(
          (parameter) => parameter.id === parameterData.parameterId,
        );
        if (!parameter) return parameterData.parameterId.toString();
        return `${parameter.subcategory || ''} ${parameter.name}`;
      }) || []
    );
  }

  getVirtualFenceString(row: dsDtos.Command | webDtos.CustomerCommand) {
    const rules = row?.virtualFenceConstructionRules;
    if (!rules?.length) return undefined;
    return `Virtual Fence`;
  }

  getCombinedStrings(
    row: dsDtos.Command | webDtos.CustomerCommand,
    parameters: dsDtos.Parameter[],
  ) {
    const commandString = this.getCommandString(row);
    const scheduleStrings = this.getScheduleStrings(row);
    const parameterStrings = this.getParameterStrings(row, parameters);
    const virtualFenceString = this.getVirtualFenceString(row);
    const combined: string[] = [];
    if (commandString) combined.push(commandString);
    if (scheduleStrings) combined.push(...scheduleStrings);
    if (parameterStrings) combined.push(...parameterStrings);
    if (virtualFenceString) combined.push(virtualFenceString);
    return combined;
  }

  getCombinedString(row: dsDtos.Command | webDtos.CustomerCommand, parameters: dsDtos.Parameter[]) {
    return this.getCombinedStrings(row, parameters).join('  ');
  }
}
